module.exports = {
	"articleTitle1": "Best Dessert: Iorio's ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Iorio's Gelateria",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-iorios",
	"articleSnippet1": "Apr 2, 2017 ... No matter what your 3 a.m self will tell you, not all dessert is created equal, and \nIorio's proves that point.",
	"articleSnippet2": "Apr 3, 2016 ... Want something sweet? Try Iorio's Gelateria. Gelato is made with milk instead of \ncream (read: less fat than ice cream), whipped slowly for a ...",
	"foodRecommendations": [
		{
			"text": "If you're looking for some great gelato, look no further. There really aren't too many other gelato places on campus anyway.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Best Ice Cream/Frozen Yogurt/Gelato: Iorio's Gelateria ",
	"address": "522 E William St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/iorios%3Arb.jpg?itok=Dcu_XG7f",
			"author": "Robert Buechler",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.277697,
		"lng": -83.742249
	},
	"totalMisc": 1,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1,
		"bestofaa": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/iorios.json
// module id = 896
// module chunks = 0